/**
 * IPD dashboard API (day-1 S2 "Admission Dashboard", frozen contract C-#2).
 * PERMISSION-gated server-side (`require_permission(VIEW_IPD_DASHBOARD)`,
 * RBAC-IPD BE-1) — orthogonal permission slug from `ipdReportsApi`'s
 * ipd-deposits report (VIEW_IPD_REVENUE).
 */

import apiClient from './apiClient';

const BASE = '/api/organisation/reports/ipd-dashboard';

function parseError(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === 'object' && !Array.isArray(detail) && detail.code) {
    const { code, message, ...extras } = detail;
    return { error: message || fallback, code, ...extras };
  }
  if (typeof detail === 'string') return { error: detail };
  switch (error?.response?.status) {
    case 401: return { error: 'Session expired. Please login again.' };
    case 403: return { error: 'You do not have permission to view this dashboard.' };
    case 503: return { error: 'The dashboard is temporarily unavailable. Try again shortly.', code: 'IPD_TABLE_UNAVAILABLE' };
    default:  return { error: fallback };
  }
}

/**
 * GET /reports/ipd-dashboard — the ONE aggregate read backing the default
 * Admission Dashboard pane (no patient pinned). No params (server scopes
 * "today" to org-local IST, like the deposits report). Flat envelope:
 * { date, admitted_count, deposit_held_paise, collected_today_paise,
 *   low_deposit_count, beds: { configured, occupied, total, free } }.
 */
export const getIpdDashboard = async () => {
  try {
    const response = await apiClient.get(BASE);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('[IpdDashboardApi] getIpdDashboard error:', error);
    return { success: false, ...parseError(error, 'Failed to load the dashboard.') };
  }
};

const ipdDashboardApi = { getIpdDashboard };

export default ipdDashboardApi;
